import React from "react";
import { Stack, Typography } from "@mui/material";
import { T } from "../routes/Translate";

const formatCurrency = (value) => `$${Number(value || 0).toFixed(2)}`;

// Estas dos insignias (offer/savings) siempre tienen su propio fondo oscuro
// fijo, sin importar el tema activo de la página, así que su texto también
// debe quedar fijo (no usar brandColors.accent, que en Modo Claro se vuelve
// oscuro para leerse sobre fondos claros y quedaría ilegible acá).
const styles = {
  offer: {
    fontSize: "0.9rem",
    backgroundColor: "#1f2a63",
    color: "#c7d2ff",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    fontWeight: 500,
  },
  previousPrice: {
    fontSize: "0.9rem",
    color: "text.secondary",
    textDecoration: "line-through",
    display: "block",
    width: "100%",
  },
  savings: {
    fontSize: "0.9rem",
    backgroundColor: "#1e4620",
    color: "#baffc9",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    fontWeight: 500,
  },
};

const DiscountPriceBreakdown = ({ originalPrice, discountPercent, finalPrice }) => {
  const savings = Math.max(Number(originalPrice) - Number(finalPrice), 0);

  return (
    <Stack spacing={1} alignItems="stretch">
      <Typography sx={styles.offer}>
        <T>Precio: {formatCurrency(finalPrice)}</T>
      </Typography>
      <Typography sx={styles.offer}>
        <T>Descuento: {discountPercent}%</T>
      </Typography>
      <Typography sx={styles.previousPrice}>
        <T>Antes: {formatCurrency(originalPrice)}</T>
      </Typography>
      <Typography sx={styles.savings}>
        <T>Ahorras: {formatCurrency(savings)}</T>
      </Typography>
    </Stack>
  );
};

export default DiscountPriceBreakdown;
